import React from 'react';
import { Container, Card, Row, Col} from 'react-bootstrap';
import r1 from '../../../images/gallery/pic5.jpg'
import r2 from '../../../images/gallery/pic6.jpg'
import r3 from '../../../images/gallery/pic7.jpg'

import { useTranslation } from 'react-i18next';

const RecipeAndAdvice = () => {
  const { t } = useTranslation();

  const recipeTip = t('landing.recipeAdvice.list', { returnObjects: true });

  return (
    <section id="recipeadvice" className="py-5">
      <Container style={{ paddingTop: '50px' }}>
        <h2 className="text-center mb-5"
          style={{
            backgroundColor: '#90EE90',
            color: '#fff',
            border: '1px solid #CECECE',
            paddingTop: '35px',
            paddingBottom: '25px',
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)'
          }}>
          {t('landing.recipeAdvice.title')}
        </h2>

        <p className="text-center mb-5">
          {t('landing.recipeAdvice.intro')}
        </p>

        <Row>
          {recipeTip.map((rec, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="card-hover">
                <Card.Img variant="top" src={r1} alt={rec.name} className="image-recipe" />
                <Card.Body>
                  <Card.Text style={{ fontSize: '17px', fontWeight: 'bold', color: 'black' }}>
                    {rec.name}
                  </Card.Text>
                  <br />
                  <Card.Text className="text-justify">
                    <button
                      style={{ color: 'blue', backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => { /* Action à réaliser */ }}
                    >
                      {rec.description}
                    </button>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default RecipeAndAdvice;